import * as yup from 'yup'

export class VehicleCheckInDriverAirbagPhotoDto {
  documentGuid?: string = undefined
  displayFileName?: string = undefined
    vehicleCheckInDriverAirbagPhotoFile?: File = undefined
}

export const vehicleCheckInDriverAirbagPhotoValidationSchema = yup.object({
  vehicleCheckInDriverAirbagPhotoFile: yup.mixed().notRequired()
})
